import { createFileRoute } from "@tanstack/react-router"
import { SchedulePageWrapper } from "./-SchedulePage"

export const Route = createFileRoute("/schedule")({
  component: SchedulePageWrapper,
})
